import { storage } from '@innovamat/radiance-utils';
import { create } from 'zustand';

const COOKIE_NAME = storage.StorageKeys.PrintingToolConfiguration;

export type PrintingToolConfigurationType = {
  guideIds: string[];
  region: string | null | undefined;
  language: string | null | undefined;
  standard: string | null | undefined;
  blockOptions: string[];
  commonAttributes: string[];
  commonTips: string[];
  signedTips: string[];
  courseOrder: number | null | undefined;
  acceptedTypes: {
    commonTips: string[];
    signedTips: string[];
  };
  autoBreakPage: boolean;
};

type PrintingToolState = {
  configuration: PrintingToolConfigurationType;
  updateConfiguration: (
    updates: Partial<PrintingToolConfigurationType>
  ) => void;
};

export const DEFAULT_CONFIGURATION: PrintingToolConfigurationType = {
  guideIds: [],
  region: undefined,
  language: undefined,
  standard: undefined,
  blockOptions: [],
  commonAttributes: [],
  commonTips: [],
  signedTips: [],
  courseOrder: null,
  acceptedTypes: {
    commonTips: [],
    signedTips: [],
  },
  autoBreakPage: false,
};

const getStoredConfiguration = (): PrintingToolConfigurationType => {
  const storedConfig = localStorage.getItem(COOKIE_NAME);
  if (!storedConfig) return DEFAULT_CONFIGURATION;

  try {
    return JSON.parse(storedConfig);
  } catch {
    return DEFAULT_CONFIGURATION;
  }
};

export const usePrintingToolStore = create<PrintingToolState>((set) => ({
  configuration: getStoredConfiguration(),
  updateConfiguration: (updates) =>
    set((state) => {
      const newConfiguration = {
        ...state.configuration,
        ...updates,
      };

      localStorage.setItem(COOKIE_NAME, JSON.stringify(newConfiguration));

      return {
        configuration: newConfiguration,
      };
    }),
}));
